import { useState } from 'react';
import type { DetailRow } from '../../shared/contracts';
import { paneById } from '../../shared/pane-catalog';
import { PaneLoader } from './PaneLoader';
import { OpslagModal } from './OpslagModal';
import { QuickLinks } from './QuickLinks';

const AGENDA = paneById('admin.myAgenda');
const BOARD = paneById('admin.board');

/**
 * Top of the overview: the user's personal agenda alongside the notice board (each half a
 * row on desktop, stacked on mobile), then a full-width quick-links strip. Both panes load
 * through PaneLoader so they get the same skeleton/error/last-good lifecycle as the KPI grid
 * (a failed pane shows an error card, not an endless skeleton), and share one opslag modal.
 */
export function OverviewTop() {
  const [opslag, setOpslag] = useState<DetailRow | null>(null);
  // Agenda/board open their content in the opslag modal, not the drill modal.
  const noDrill = () => {};
  return (
    <div className="mb-6 space-y-4">
      <div className="grid items-start gap-4 md:grid-cols-2">
        {AGENDA && <PaneLoader descriptor={AGENDA} onDrill={noDrill} onOpslag={setOpslag} showEyebrow={false} />}
        {BOARD && <PaneLoader descriptor={BOARD} onDrill={noDrill} onOpslag={setOpslag} showEyebrow={false} />}
      </div>
      <QuickLinks />
      {opslag && <OpslagModal row={opslag} onClose={() => setOpslag(null)} />}
    </div>
  );
}
